import * as z from "zod";
import { FlipDirection } from "../constants";

export const imageRotationSchema = z.number();

export const imageFlipDirectionSchema = z.nativeEnum(FlipDirection);
